import Component from './component.styles'
export default Component
